<template>
  <div>
    <a-table
        :columns="[
            {
                dataIndex: 'destinations',
                key: 'destinations',
                width: 10,
                align: 'start',
                justify: 'start'
            },
            {
                dataIndex: 'moving_type',
                key: 'moving_type',
                width: 20,
                align: 'end'
            },
            {
                dataIndex: 'product_amount',
                key: 'product_amount',
                width: 20,
                align: 'end'
            },
            {
                dataIndex: 'product_weight',
                key: 'product_weight',
                width: 20,
                align: 'end'
            },
            {
                dataIndex: 'action',
                key: 'action',
                width: 40,
                align: 'center',
                justify: 'center'
            }
        ]"
        :data-source="destinations"
        bordered
        size="medium"
        :show-header="false"
        :pagination="false"
    >
        <!-- Column header slot -->
        <template #title="{ column }">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <span style="font-weight: 500;">ปลายทาง</span>
                <a-space>
                    <a-button size="medium" @click="showRouteDrawerInitial" :disabled="destinations.length <= 1 || originData.length === 0 || disabled">
                        <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 4px;">rule_settings</span>
                        ใช้ระบบช่วยคำนวณเส้นทาง
                    </a-button>
                    <a-button type="primary" size="medium" @click="resetForm(), showDrawer = true" :disabled="disabled">
                        <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 4px;">Add</span>
                        เพิ่มปลายทาง
                    </a-button>
                </a-space>
            </div>
        </template>

        <!-- Column cell slot -->
        <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'destinations'">
                <a-space>
                   <div style="display: flex; flex-direction: space-between; align-items: center; justify-content: center;gap: 15px;">
                        <a 
                            class="material-symbols-outlined"
                            :class="{ disabled: disabled }"
                            @click="moveUp(index)"
                            style="cursor: pointer; font-size: 20px; color: #555;"
                            :disabled="statusDisable||disabled"
                        >
                        arrow_upward
                        </a>
                        <a 
                            class="material-symbols-outlined"
                            :class="{ disabled: disabled }"
                            @click="moveDown(index)"
                            style="cursor: pointer; font-size: 20px; color: #555;"
                            :disabled="statusDisable||disabled"
                            wi
                        >
                        arrow_downward
                        </a>
                    </div>
                    {{  record?.name  }}
                </a-space>
            </template>
            <template v-if="column.key === 'moving_type'">
                {{ moveTypeLabel(record.moving_type) }}
            </template>
            <template v-if="column.key === 'product_amount'">
                {{ record.product_amount }} ชิ้น
            </template>
            <template v-if="column.key === 'product_weight'">
                {{ record.product_weight }} กิโลกรัม
            </template>
            <template v-if="column.key === 'action'">
              <a-space>
                <span style="display: flex; align-items: center; justify-content: center;">
                    <a @click="editDestination(record,index)" style="font-size: 18px; vertical-align: middle;" :class="{ disabled: disabled }"
                    class="material-symbols-outlined">
                      drive_file_rename_outline
                    </a>
                </span>
                <span style="display: flex; align-items: center; justify-content: center;">
                    <a @click="remove_destination(record)" style="font-size: 18px; vertical-align: middle;" :class="{ disabled: disabled }"
                    class="material-symbols-outlined">
                      delete
                    </a>
                </span>
              </a-space>
            </template>
        </template>
    </a-table>

    <!-- ═══════════════════════ ช่วยคำนวณเส้นทาง drawer ═══════════════════════ -->
    <a-drawer v-model:visible="showRouteDrawer" title="ช่วยคำนวณเส้นทาง" :footer="null" width="700" @close="handleRouteDrawerClose">
      <template #title>
        <div style="display:flex; align-items:center; gap:8px;">
          <span>ช่วยคำนวณเส้นทาง</span>

          <span
            v-if="isComputingRoute"
            class="material-symbols-outlined spin-icon"
            style="font-size:18px;color:#1890ff;"
            title="กำลังคำนวณ..."
          >autorenew</span>

          <a-tooltip v-else-if="usedCachedRoute" title="ใช้ผลลัพธ์เดิมที่เคยคำนวณไว้ ไม่ได้เรียก API ใหม่">
            <span class="material-symbols-outlined" style="font-size:18px;color:#52c41a;">history</span>
          </a-tooltip>

          <a-tooltip v-else-if="routeRows.length > 0" title="คำนวณเส้นทางใหม่เรียบร้อยแล้ว">
            <span class="material-symbols-outlined" style="font-size:18px;color:#52c41a;">check_circle</span>
          </a-tooltip>
        </div>
      </template>
      <div style="margin-bottom: 16px; color: #666; font-size: 13px;">
        ระบบช่วยคำนวณเส้นทางนี้จะคำนวณตามระยะทางแต่ละจุดที่วิ่งจริงที่คุ้มค่าที่สุด และสั้นที่สุด
      </div>

      <!-- ─── แผนที่ ─── -->
      <div ref="routeMapContainer" class="route-map-container"></div>

      <!-- ─── การ์ดสรุป 3 ใบ ─── -->
      <div class="summary-cards" v-if="routeRows.length > 0">
        <div class="summary-card">
          <span class="material-symbols-outlined summary-icon">home_pin</span>
          <div class="summary-text">
            <div class="summary-title">รวม {{ routeRows.length }} จุดหมาย</div>
            <div class="summary-sub">1 ต้นทาง {{ routeRows.length - 1 }} ปลายทาง</div>
          </div>
        </div>
        <div class="summary-card">
          <span class="material-symbols-outlined summary-icon">route</span>
          <div class="summary-text">
            <div class="summary-title">ระยะทางรวม</div>
            <div class="summary-sub">{{ totalDistanceText }} กิโลเมตร</div>
          </div>
        </div>
        <div class="summary-card">
          <span class="material-symbols-outlined summary-icon">schedule</span>
          <div class="summary-text">
            <div class="summary-title">เวลารวมโดยประมาณ</div>
            <div class="summary-sub">{{ workHourText }}</div>
          </div>
        </div>
      </div>
      <div v-if="consumptionRateSuggestValue > 0" style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px; margin-top: 16px; font-weight: 600;">
        <span class="material-symbols-outlined" style="color:#1890ff; font-size: 25px;">local_gas_station</span>
        <div class="summary-title" style="color: black; font-size: 16px;">ประมาณการเชื้อเพลิง</div>
      </div>
      <div class="summary-cards" v-if="consumptionRateSuggestValue > 0">
        <div class="summary-card">
          <span class="material-symbols-outlined summary-icon">local_gas_station</span>
          <div class="summary-text">
            <div class="summary-title">อัตราสิ้นเปลือง</div>
            <div class="summary-sub">{{ consumptionRateSuggestValue || '-' }} กม./ลิตร</div>
          </div>
        </div>
        <div class="summary-card-2">
          <span class="material-symbols-outlined summary-icon">oil_barrel</span>
          <div class="summary-text">
            <div class="summary-title" style="font-size: 10px;">ปริมาณเชื้อเพลิงที่คาดการณ์</div>
            <div class="summary-sub">{{ computedAmountGas || '-' }} ลิตร</div>
          </div>
        </div>
        <div class="summary-card-3">
          <span class="material-symbols-outlined summary-icon-2">payments</span>
          <div class="summary-text">
            <div class="summary-title">ค่าเชื้อเพลิงโดยประมาณ</div>
            <div class="summary-sub">{{ computedPriceGas || '-' }} บาท</div>
          </div>
        </div>
      </div>

      <div v-if="consumptionRateSuggestValue > 0" class="summary-card-4" style="justify-content: center;">
        <div class="summary-text" style="color: black; font-weight: 500;">
          <div class="summary-title">คำนวณจากระยะทาง {{ distanceSuggestValue }} กม. และราคาน้ำมัน {{ (computedPriceGas/computedAmountGas).toFixed(2) || '-' }} บาท/ลิตร</div>
        </div>
      </div>

      <!-- ─── ตารางรายละเอียดแต่ละจุด ─── -->
      <a-table
        :columns="[
            { title: 'ลำดับ', dataIndex: 'order_label', key: 'order_label', width: 70, minWidth: 70 },
            { title: 'จุดรับ-ส่ง', dataIndex: 'name', key: 'name', width: 220, ellipsis: true },
            { title: 'ประเภทการเคลื่อนย้าย', dataIndex: 'moving_type', key: 'moving_type', align: 'center', width: 150 },
            { title: 'จำนวนชิ้น', dataIndex: 'product_amount', key: 'product_amount', align: 'center', width: 100 },
            { title: 'น้ำหนัก (กก.)', dataIndex: 'product_weight', key: 'product_weight', align: 'center', width: 110 },
            { title: 'ระยะทางสะสม (กม.)', dataIndex: 'cumulative_distance', key: 'cumulative_distance', align: 'center', width: 130 },
            { title: 'เวลาประมาณการ', dataIndex: 'eta', key: 'eta', align: 'center', width: 120 },
        ]"
        :data-source="routeRows"
        bordered
        size="small"
        :pagination="false"
        style="margin-top: 16px; width: 100%;"
        :scroll="{ x: 900 }"
        table-layout="auto"
      >
        <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'order_label'">
                <div style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                    <span class="row-index">{{ index + 1 }}</span>
                    <span class="stop-badge" :class="{ 'stop-badge--origin': record.isOrigin }">
                        {{ record.isOrigin ? 'A' : record.stopNumber }}
                    </span>
                </div>
            </template>
            <template v-if="column.key === 'moving_type'">
                {{ moveTypeLabel(record.moving_type) }}
            </template>
            <template v-if="column.key === 'product_amount'">
                {{ `${record.product_amount} ชิ้น` }}
            </template>
            <template v-if="column.key === 'product_weight'">
                {{ `${record.product_weight} กิโลกรัม` }}
            </template>
            <template v-if="column.key === 'cumulative_distance'">
                {{ record.cumulative_distance }}
            </template>
        </template>
      </a-table>

      <!-- ─── แถบข้อมูลด้านล่าง ─── -->
      <div class="bottom-info-bar" v-if="routeRows.length > 0">
        <div class="bottom-info-item">
          <span class="material-symbols-outlined" style="font-size: 18px;color: #1890ff;">calendar_month</span>
          <div>
            <div class="bottom-info-label">วันเริ่มรับ - ส่ง</div>
            <div class="bottom-info-value">{{ datetimeFormat(datetime) }}</div>
          </div>
        </div>
        <div class="bottom-info-item">
          <span class="material-symbols-outlined" style="font-size: 18px;color: #1890ff;">timer</span>
          <div>
            <div class="bottom-info-label">ใช้เวลาในการวิ่งงาน</div>
            <div class="bottom-info-value">{{ workHourText }}</div>
          </div>
        </div>
        <div class="bottom-info-item">
          <span class="material-symbols-outlined" style="font-size: 18px;color: #1890ff;">local_shipping</span>
          <div>
            <div class="bottom-info-label">ประเภทรถที่แนะนำ</div>
            <div class="bottom-info-value">
              {{ orderedCarOptions?.find((item)=> item.allHaveWork == false && item.leftWeight >= 0)?.label }}
              | มีพื้นที่เหลือ {{ orderedCarOptions?.find((item)=> item.allHaveWork == false && item.leftWeight >= 0)?.leftWeight }} กิโลกรัม
            </div>
          </div>
        </div>
      </div>

      <a-space 
        v-if="orderedCarOptions.find((item)=> item.recommended == true)?.disabled == true"
        class="grey-alert"
        style="width: 100%; align-items: flex-start; font-size: 12px; margin-top: 16px;"
      >
        <span class="material-symbols-outlined" style="font-size: 16px; margin-top: 3px;">info</span>
        <div style="display: flex; flex-direction: column; padding-left: 0px;">
          <span>รถที่คุ้มค่าที่สุดคือ {{orderedCarOptions?.find((item)=> item.recommended == true)?.label}} มีที่ว่าง {{orderedCarOptions?.find((item)=> item.recommended == true)?.leftWeight}} กิโลกรัม</span>
          <span>แต่ไม่สามารถให้บริการได้ในวันที่คุณเลือก</span>
        </div>
      </a-space>

      <a-row justify="end" style="margin-top: 16px;">
        <a-button type="primary" block size="large" @click="handleSubmitSuggest" :disabled="routeRows.length === 0">
          <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 4px; vertical-align: middle;">save</span>
          ใช้เส้นทางที่แนะนำ
        </a-button>
      </a-row>
    </a-drawer>

    <a-drawer v-model:visible="showDrawer" title="เพิ่มปลายทาง" :footer="null">
      <a-form :model="form" layout="vertical" @finish="handleSubmit" ref="destinationForm">
        <a-form-item label="ปลายทาง" name="name" :rules="[{ required: true, message: 'กรุณาระบุปลายทาง' }]">
          <SourcePlaceInput 
            v-if="isProjectValue"
            :clientId="clientId"
            v-model="form.name" 
            placeHolderText="ปลายทาง"
            @placeSelected="handleSourceChange" />
          <a-select
            v-else
            v-model:value="form.name"
            @change="handleSourceChange"
            show-search
            :options="oldOptionSelect.length > 0 ? oldOptionSelect : optionsSelect"
            :key="formKey"
          ></a-select>
        </a-form-item>
        <a-form-item label="การเคลื่อนย้ายสินค้า" name="moving_type" :rules="[{ required: true, message: 'กรุณาเลือกประเภท' }]">
          <a-radio-group v-model:value="form.moving_type">
            <a-radio :value="1">ยกสินค้าขึ้น</a-radio>
            <a-radio :value="2">เอาสินค้าลง</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-row gutter="16">
          <a-col :span="12">
            <a-form-item label="จำนวนชิ้นพัสดุ (ชิ้น)" name="product_amount" :rules="[{ required: true, message: 'กรุณาระบุจำนวนชิ้นพัสดุ' }]">
              <a-input v-model:value="form.product_amount" placeholder="จำนวนชิ้นพัสดุ" type="number" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="น้ำหนักพัสดุ (กิโลกรัม)" name="product_weight" :rules="[{ required: true, message: 'กรุณาระบุน้ำหนักพัสดุ' }]">
              <a-input v-model:value="form.product_weight" placeholder="น้ำหนักพัสดุ" type="number" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row justify="end">
          <a-button type="primary" html-type="submit" :disabled="!form.name || !form.moving_type || !form.product_amount || !form.product_weight">
            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Save</span>
            บันทึก
          </a-button>
        </a-row>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import { options } from '@fullcalendar/core/preact';
import SourcePlaceInput from './SourcePlaceInput.vue';
export default {
  name: 'destination_table_drawer',
  components: { SourcePlaceInput },
  props: {
    isProjectValue: Boolean,
    disabled: Boolean,
    optionsSelect: {
      type: Array,
      default: () => []
    },
    destinations: {
      type: Array,
      default: () => []
    },
    clientId: {
      type: Number,
      default: 0
    },
    datetime: {
      type: Array,
      default: () => []
    },
    workHour: {
      type: Number,
      default: 0
    },
    createData: {
      type: Object,
      default: () => ({})
    },
    optionCar: {
      type : Array,
      default: () => []
    },
    optionCarAvailable: {
      type : Array,
      default: () => []
    },
    originData:{
      type: Array,
      default: () => []
    },
    oilPrice: {
      type: Number,
      default: 0
    },
    // ── ใหม่: ชื่อ/ที่อยู่ต้นทาง สำหรับแสดงในตาราง+แผนที่ ──
    // ถ้า parent component ยังไม่ได้ส่ง prop นี้มา จะ fallback เป็น "ต้นทาง" เฉยๆ
    originName: {
      type: String,
      default: 'ต้นทาง'
    },
    originAmount: {
      type: String,
      default: ''
    },
    originWeight: {
      type: String,
      default: ''
    },
    originMoving: {
      type: Number,
      default: 1
    },
    // ── ใหม่: เวลาที่เริ่มออกเดินทาง ใช้คำนวณ ETA ต่อจุด เช่น "08:00" ──
    startTime: {
      type: String,
      default: '08:00'
    }
  },
  emits: [
    'destinationText',
    'moveUp',
    'moveDown',
    'remove_destination',
    'triggerValidateFields',
  ],
  computed: {
    computedAmountGas() {
      if (this.distanceSuggestValue > 0 && this.consumptionRateSuggestValue > 0) {
        return (this.distanceSuggestValue / this.consumptionRateSuggestValue).toFixed(2);
      }
      return null;
    },
    computedPriceGas() {
      if (this.computedAmountGas && this.oilPrice) {
        return (this.computedAmountGas * this.oilPrice).toFixed(2);
      }
      return null;
    },
    orderedCarOptions(){
      const listCar = this.optionCar.map(({ id, name, loadable_weight, latest_gas_detail }) => ({
                        value: id,
                        label: name,
                        loadableWeight: loadable_weight,
                        leftWeight: (loadable_weight) - this.computedCarSuggest('sum_weight_value'),
                        allHaveWork: (() => {
                                      const cars = this.getAvailableCarFormat(id);
                                      return cars.length > 0 && cars.every(item => item.disabled === true);
                                    })(),
                        consumption_rate:  Number(latest_gas_detail?.consumption_rate) || 0,
                      }));
      const sorted = listCar
        .map(o => ({
          ...o,
          disabled: o.allHaveWork,
        }))
        .sort((a, b) => {
          const rank = (car) => {
            if (car.allHaveWork) return 3;
            if (car.leftWeight < 0 || car.leftWeight == null) return 2; 
            return 1;
          };
          if (rank(a) !== rank(b)) return rank(a) - rank(b);
          return a.leftWeight - b.leftWeight;
        });
      if (sorted.length > 0) {
        const candidate = sorted
        .filter(o => o.leftWeight >= 0)
        .reduce((min, cur) => 
          min === null || cur.leftWeight < min.leftWeight ? cur : min
        , null);

        if (candidate) {
          candidate.recommended = true;
        }
      }
      return sorted;
    },
  },
  data() {
    return {
      showDrawer: false,
      editingIndex: null,
      form: {
        name: '',
        moving_type: 1,
        product_amount: '',
        product_weight: ''
      },
      suggestValue: [],
      showRouteDrawer: false,
      workHourText: '',
      workHourSuggestValue: 0,
      distanceSuggestValue: 0,
      consumptionRateSuggestValue: 0,
      formKey: 0,
      oldOptionSelect:[],

      // ── state ใหม่สำหรับแผนที่ + ตารางแบบละเอียด ──
      routeRows: [],          // แถวสำหรับตาราง (มี cumulative distance/time ต่อจุด)
      totalDistanceText: '0',
      mapInstance: null,
      mapMarkers: [],
      mapInfoWindows: [],
      mapPolyline: null,
      isComputingRoute: false,
      usedCachedRoute: false,
      lastRouteCacheKey: null,
      lastRouteCache: null,
      lastComputedOrder: null,
      lastComputedRouteResponse: null,
      oilRangeArray:[
        28,30,32,34,36
      ]
    };
  },
  methods: {
    remove_destination(record){
      this.$emit("remove_destination", record);
    },
    moveUp(index){
      this.$emit("moveUp", index);
    },
    moveDown(index){
      this.$emit("moveDown", index);
    },
    datetimeFormat(value){
      if(value && value.length > 0){
        return value[0].format('DD/MM/YYYY') + ' - ' + value[1].format('DD/MM/YYYY')
      }else{
        return ''
      }
    },
    computedCarSuggest(type) {
      const sequence = [];

      if (this.createData.moving_type == 'up') {
        sequence.push({
          type: 'up',
          weight: Number(this.createData.product_weight || 0),
          amount: Number(this.createData.product_amount || 0)
        });
      }
      const routeRowsWithoutOrigin = this.routeRows.filter(dest => !dest.isOrigin);
      routeRowsWithoutOrigin.forEach(dest => {
        sequence.push({
          type: dest.moving_type == 1 ? 'up' : 'down',
          weight: Number(dest.product_weight || 0),
          amount: Number(dest.product_amount || 0)
        });
      });

      let currentWeight = 0, peakWeight = 0;
      let currentAmount = 0, peakAmount = 0;

      for (const step of sequence) {
        if (step.type === 'up') {
          currentWeight += step.weight;
          currentAmount += step.amount;
        } else {
          currentWeight -= step.weight;
          currentAmount -= step.amount;
        }

        if (currentWeight > peakWeight) peakWeight = currentWeight;
        if (currentAmount > peakAmount) peakAmount = currentAmount;

      }
      if (type === 'sum_weight') {
        return peakWeight.toLocaleString() + ' กิโลกรัม';
      } else if (type === 'sum_amount') {
        return peakAmount.toLocaleString() + ' กล่อง';
      } else if (type === 'sum_weight_value'){
        return Number(peakWeight);
      }else {
        const suitableCars = this.car_type_list.filter(
          car => Number(car.loadable_weight) >= Number(peakWeight)
        );

        if (suitableCars.length === 0) return null;

        const bestCar = suitableCars.reduce(
          (prev, curr) =>
            Number(curr.loadable_weight) < Number(prev.loadable_weight) ? curr : prev
        );

        return this.routeRows.length > 0 
        ? bestCar.name +
          ' | สามารถจุได้อีก ' +
          ((bestCar.loadable_weight) - peakWeight).toLocaleString() +
          ' กิโลกรัม' 
        : null;
      }
    },
    getAvailableCarFormat(car_type_id){
      return this.optionCarAvailable
        .filter(car => car.car_company_id == this.createData.car_company_id &&
          car.car_type_id == car_type_id)
        .map(
        ({ id, plate_no, car_no, car_type_id, repair_time_end, repair_time_start, car_repair_status_id, hasWork }) => {
          return {
            value: id,
            car_type_id: car_type_id,
            disabled: hasWork,
          }
        }
      )
    },
    handleSubmitSuggest(){
      this.$emit("update:destinations", this.suggestValue);
      this.$emit("update:work_hour", this.workHourSuggestValue);
      this.$emit("update:consumption_rate", this.consumptionRateSuggestValue);
      this.$emit("update:distance", this.distanceSuggestValue);
      this.$emit("update:car_type_id",this.orderedCarOptions?.find((item)=> item.allHaveWork == false && item.leftWeight >= 0)?.value)
      this.showRouteDrawer = false
      this.$nextTick(() => {
        this.$emit("triggerValidateFields", ["work_hour", "distance","car_type_id"]);
      });
    },

    // เรียกเมื่อปิด drawer — เคลียร์ map overlays + ทำลาย map instance ทิ้งเลย
    // เพื่อให้เปิดใหม่ครั้งหน้าสร้างแผนที่สะอาดๆ (center/zoom ใหม่ตามต้นทางล่าสุด)
    handleRouteDrawerClose() {
      this.clearMapOverlays();
      this.mapInstance = null;
    },

    // แปลงวินาที → "HH:mm น." โดยบวกจาก startTime prop
    formatClockTime(baseTimeStr, secondsToAdd) {
      const [h, m] = baseTimeStr.split(':').map(Number);
      const base = new Date();
      base.setHours(h, m, 0, 0);
      base.setSeconds(base.getSeconds() + secondsToAdd);
      const hh = String(base.getHours()).padStart(2, '0');
      const mm = String(base.getMinutes()).padStart(2, '0');
      return `${hh}:${mm} น.`;
    },

    // ล้าง markers/polyline/infowindows เดิมออกจากแผนที่ก่อนวาดใหม่
    clearMapOverlays() {
      this.mapMarkers.forEach(m => m.setMap(null));
      this.mapMarkers = [];
      this.mapInfoWindows.forEach(iw => iw.close());
      this.mapInfoWindows = [];
      if (this.mapPolyline) {
        this.mapPolyline.setMap(null);
        this.mapPolyline = null;
      }
    },

    // วาดแผนที่: origin (A) + จุดหมายตามลำดับที่คำนวณ + เส้นทาง
    // legs = array ของ leg ที่เกี่ยวข้อง (แต่ละ leg คือช่วงระหว่างจุดสองจุดที่ติดกัน)
    renderRouteMap(origin, orderedStops, legs) {
      if (!this.$refs.routeMapContainer) return;

      this.clearMapOverlays();

      if (!this.mapInstance) {
        this.mapInstance = new google.maps.Map(this.$refs.routeMapContainer, {
          zoom: 11,
          center: origin,
          disableDefaultUI: true,
          zoomControl: true,
        });
      }

      const bounds = new google.maps.LatLngBounds();

      // ── หมุดต้นทาง (A) — สีส้ม ──
      const originMarker = new google.maps.Marker({
        position: origin,
        map: this.mapInstance,
        label: { text: 'A', color: '#fff', fontWeight: 'bold', fontSize: '13px' },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 15,
          fillColor: 'green',
          fillOpacity: 1,
          strokeColor: '#fff',
          strokeWeight: 2,
        },
      });
      const originInfoWindow = new google.maps.InfoWindow({
        content: `<div style="font-size:12px;font-weight:600;max-width:180px;">ต้นทาง<br/><span style="font-weight:400;">${this.originName}</span></div>`,
      });
      originMarker.addListener('mouseover', () => {
        originInfoWindow.open(this.mapInstance, originMarker);
      });
      originMarker.addListener('mouseout', () => {
        originInfoWindow.close();
      });
      this.mapMarkers.push(originMarker);
      this.mapInfoWindows.push(originInfoWindow);
      bounds.extend(origin);

      // ── หมุดจุดหมายแต่ละจุด (1, 2, 3, ...) — สีแดง ──
      orderedStops.forEach((stop, idx) => {
        const position = { lat: Number(stop.lat), lng: Number(stop.lng) };
        const marker = new google.maps.Marker({
          position,
          map: this.mapInstance,
          label: { text: String(idx + 1), color: '#fff', fontWeight: 'bold', fontSize: '13px' },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 15,
            fillColor: '#ef4444',
            fillOpacity: 1,
            strokeColor: '#fff',
            strokeWeight: 2,
          },
        });
        const infoWindow = new google.maps.InfoWindow({
          content: `<div style="font-size:12px;font-weight:600;max-width:180px;">จุดหมาย ${idx + 1}<br/><span style="font-weight:400;">${stop.name}</span></div>`,
        });
        marker.addListener('mouseover', () => {
          infoWindow.open(this.mapInstance, marker);
        });
        marker.addListener('mouseout', () => {
          infoWindow.close();
        });
        this.mapMarkers.push(marker);
        this.mapInfoWindows.push(infoWindow);
        bounds.extend(position);
      });

      // ── เส้นทาง — ต่อ path ละเอียดจากทุก step ของทุก leg ──
      // (ไม่ใช้ overview_path เพราะเป็นเส้นแบบย่อ ตัดมุมไม่แนบถนนจริง)
      if (legs && legs.length > 0) {
        const detailedPath = [];
        legs.forEach(leg => {
          leg.steps.forEach(step => {
            detailedPath.push(...step.path);
          });
        });

        this.mapPolyline = new google.maps.Polyline({
          path: detailedPath,
          strokeColor: '#2563eb',
          strokeOpacity: 1,
          strokeWeight: 4,
          map: this.mapInstance,
        });
      }

      this.mapInstance.fitBounds(bounds, 60);
    },

    async showRouteDrawerInitial() {
      this.showRouteDrawer = true;
      this.usedCachedRoute = false;

      const originLatLng = JSON.parse(this.originData);
      const origin = { lat: Number(originLatLng.lat), lng: Number(originLatLng.lng) };

      const cacheKey = this.buildRouteCacheKey(origin, this.destinations);

      // ── origin + destinations เหมือนครั้งก่อนเป๊ะ → ใช้ผลลัพธ์เดิม ไม่เรียก API ซ้ำ ──
      if (this.lastRouteCacheKey === cacheKey && this.lastRouteCache) {
        this.usedCachedRoute = true;
        const cachedOrder = this.resolveCachedOrder(this.lastRouteCache.orderKeys);
        this.processRouteResponse(
          this.lastRouteCache.origin,
          this.lastRouteCache.routeResponse,
          cachedOrder
        );
        return;
      }

      // ── ข้อมูลเปลี่ยนไปจากเดิม ต้องคำนวณใหม่ ──
      this.routeRows = [];
      this.suggestValue = [];
      this.workHourText = '';
      this.totalDistanceText = '0';
      this.clearMapOverlays();
      this.isComputingRoute = true;

      try {
        await this.findOptimalRoute(origin);

        if (this.lastComputedOrder && this.lastComputedRouteResponse) {
          this.lastRouteCacheKey = cacheKey;
          this.lastRouteCache = {
            orderKeys: this.lastComputedOrder.map(index => this.destinationRouteKey(this.destinations[index])),
            routeResponse: this.lastComputedRouteResponse,
            origin,
          };
        }
      } finally {
        this.isComputingRoute = false;
      }
    },

    // ── สร้าง key ไว้เทียบว่าข้อมูล origin+destinations เหมือนครั้งก่อนไหม ──
    // เรียง destination ก่อน sort เพื่อไม่ให้ลำดับการกรอกมีผล เทียบแค่ "ชุดจุด" ที่เหมือนกัน
    buildRouteCacheKey(origin, destinations) {
      const originKey = `${origin.lat.toFixed(6)},${origin.lng.toFixed(6)}`;
      const destKeys = destinations
        .map(d => this.destinationRouteKey(d))
        .sort();
      return `${originKey}|${destKeys.join(';')}`;
    },

    destinationRouteKey(destination) {
      return `${Number(destination.lat).toFixed(6)},${Number(destination.lng).toFixed(6)}`;
    },

    resolveCachedOrder(orderKeys) {
      const availableIndexes = this.destinations.map((_, index) => index);
      return orderKeys.map(key => {
        const matchingPosition = availableIndexes.findIndex(index => (
          this.destinationRouteKey(this.destinations[index]) === key
        ));
        if (matchingPosition === -1) return null;
        return availableIndexes.splice(matchingPosition, 1)[0];
      }).filter(index => index !== null);
    },

    async findOptimalRoute(origin) {
      const destinations = this.destinations;
      let bestOrder = null;

      const matrix = await this.getDistanceMatrix(
        [origin, ...destinations.map(d => ({ lat: Number(d.lat), lng: Number(d.lng) }))]
      );

      if (matrix) {
        bestOrder = this.findBestOrderFromDistances(
          destinations,
          (fromIdx, toIdx) => matrix.distances[fromIdx][toIdx]
        );
      } else {
        console.warn('Distance Matrix unavailable, falling back to Haversine');
        const points = [origin, ...destinations.map(d => ({ lat: Number(d.lat), lng: Number(d.lng) }))];
        bestOrder = this.findBestOrderFromDistances(
          destinations,
          (fromIdx, toIdx) => this.haversineDistance(points[fromIdx], points[toIdx])
        );
      }

      if (!bestOrder) {
        this.suggestValue = [...this.destinations];
        this.routeRows = [];
        return;
      }

      // ยิง Directions API แค่ครั้งเดียว สำหรับลำดับที่ชนะ เพื่อเอา legs/polyline จริง
      const lastStop = destinations[bestOrder[bestOrder.length - 1]];
      const middleStops = bestOrder.slice(0, -1).map(i => destinations[i]);

      const directionsService = new google.maps.DirectionsService();
      const waypoints = middleStops.map(d => ({
        location: { lat: Number(d.lat), lng: Number(d.lng) },
        stopover: true
      }));
      const destination = { lat: Number(lastStop.lat), lng: Number(lastStop.lng) };

      try {
        const response = await new Promise((resolve, reject) => {
          directionsService.route(
            { origin, destination, waypoints, travelMode: google.maps.TravelMode.DRIVING },
            (response, status) => {
              if (status === 'OK') resolve(response);
              else reject(status);
            }
          );
        });

        const route = response.routes[0];
        this.lastComputedOrder = bestOrder;
        this.lastComputedRouteResponse = route;
        this.processRouteResponse(origin, route, bestOrder);
      } catch (error) {
        console.warn('Route calculation failed:', error);
        this.suggestValue = [...this.destinations];
        this.routeRows = [];
      }
    },

    // ── ลองทุก permutation คำนวณในหน่วยความจำ (ไม่มี network call) ──
    findBestOrderFromDistances(destinations, getDistance) {
      const indexes = destinations.map((_, i) => i);
      const permutations = this.generatePermutations(indexes);

      let bestOrder = null;
      let bestDistance = Infinity;

      for (const perm of permutations) {
        let total = 0;
        let prevMatrixIdx = 0; // 0 = origin เสมอ

        for (const destIdx of perm) {
          const matrixIdx = destIdx + 1; // +1 เพราะ index 0 ถูกจองไว้ให้ origin
          total += getDistance(prevMatrixIdx, matrixIdx);
          prevMatrixIdx = matrixIdx;
        }

        if (total < bestDistance) {
          bestDistance = total;
          bestOrder = perm;
        }
      }

      return bestOrder;
    },

    // ── ยิง Distance Matrix 1 ครั้ง ได้ระยะทางถนนจริงระหว่างทุกจุดคู่กัน ──
    getDistanceMatrix(points) {
      return new Promise((resolve) => {
        const service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
          {
            origins: points,
            destinations: points,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status !== 'OK') {
              console.error('Distance Matrix request failed:', status);
              resolve(null);
              return;
            }
            const distances = response.rows.map(row =>
              row.elements.map(el => el.status === 'OK' ? el.distance.value : Infinity)
            );
            resolve({ distances });
          }
        );
      });
    },

    // ── fallback: ระยะทางเส้นตรง ใช้เมื่อ Distance Matrix ใช้งานไม่ได้ ──
    haversineDistance(p1, p2) {
      const R = 6371000;
      const toRad = (deg) => (deg * Math.PI) / 180;
      const dLat = toRad(p2.lat - p1.lat);
      const dLng = toRad(p2.lng - p1.lng);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(p1.lat)) * Math.cos(toRad(p2.lat)) * Math.sin(dLng / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },

    // ── ลองทุกการจัดเรียงของปลายทาง แล้วเลือกเส้นทางที่ดีที่สุด ──
    // async findOptimalRouteByTryingAll(origin) {
    //   const directionsService = new google.maps.DirectionsService();
    //   const destinations = this.destinations;

    //   const allRoutes = [];
    //   const permutations = this.generatePermutations(destinations);

    //   for (const perm of permutations) {
    //     const lastStop = perm[perm.length - 1];
    //     const middleStops = perm.slice(0, -1);

    //     const waypoints = middleStops.map(d => ({
    //       location: { lat: Number(d.lat), lng: Number(d.lng) },
    //       stopover: true
    //     }));

    //     const destination = { lat: Number(lastStop.lat), lng: Number(lastStop.lng) };

    //     try {
    //       const response = await new Promise((resolve, reject) => {
    //         directionsService.route(
    //           {
    //             origin,
    //             destination,       // ← จุดสุดท้ายของ perm นี้ ไม่ใช่ origin
    //             waypoints,
    //             travelMode: google.maps.TravelMode.DRIVING,
    //           },
    //           (response, status) => {
    //             if (status === 'OK') {
    //               resolve(response);
    //             } else {
    //               reject(status);
    //             }
    //           }
    //         );
    //       });

    //       const route = response.routes[0];
    //       const legs = route.legs;

    //       const totalMeters = legs.reduce((sum, leg) => sum + leg.distance.value, 0);
    //       const totalSeconds = legs.reduce((sum, leg) => sum + leg.duration.value, 0);

    //       allRoutes.push({
    //         order: perm.map(d => destinations.indexOf(d)),
    //         response: route,
    //         totalMeters,
    //         totalSeconds,
    //       });
    //     } catch (error) {
    //       console.warn('Route calculation failed:', error);
    //     }
    //   }

    //   if (allRoutes.length > 0) {
    //     const bestRoute = allRoutes.reduce((best, current) =>
    //       current.totalMeters < best.totalMeters ? current : best
    //     );

    //     this.processRouteResponse(origin, bestRoute.response, bestRoute.order);
    //   } else {
    //     this.suggestValue = [...this.destinations];
    //     this.routeRows = [];
    //   }
    // },

    // // ── ใช้ Google optimizeWaypoints (เร็ว แต่อาจไม่ใช่ที่ดีที่สุด) ──
    // useQuickOptimization(origin) {
    //   const directionsService = new google.maps.DirectionsService();

    //   // ลองทุกจุดเป็น "ตัวเลือกปลายทางสุดท้าย" แล้วให้ Google optimize จุดที่เหลือ
    //   // (ยังคง lightweight กว่า brute-force permutation เต็มรูปแบบ)
    //   const destinations = this.destinations;
    //   let bestResult = null;

    //   const tryDestination = (destIndex) => {
    //     return new Promise((resolve) => {
    //       const destination = {
    //         lat: Number(destinations[destIndex].lat),
    //         lng: Number(destinations[destIndex].lng)
    //       };
    //       const waypoints = destinations
    //         .filter((_, i) => i !== destIndex)
    //         .map(d => ({
    //           location: { lat: Number(d.lat), lng: Number(d.lng) },
    //           stopover: true
    //         }));

    //       directionsService.route(
    //         {
    //           origin,
    //           destination,
    //           waypoints,
    //           optimizeWaypoints: true,
    //           travelMode: google.maps.TravelMode.DRIVING,
    //         },
    //         (response, status) => {
    //           if (status === "OK") {
    //             const route = response.routes[0];
    //             const totalMeters = route.legs.reduce((s, l) => s + l.distance.value, 0);
    //             resolve({ destIndex, route, totalMeters });
    //           } else {
    //             resolve(null);
    //           }
    //         }
    //       );
    //     });
    //   };

    //   Promise.all(destinations.map((_, i) => tryDestination(i))).then((results) => {
    //     const valid = results.filter(r => r !== null);
    //     if (valid.length === 0) {
    //       this.suggestValue = [...this.destinations];
    //       this.routeRows = [];
    //       console.error("Directions request failed for all candidates");
    //       return;
    //     }

    //     bestResult = valid.reduce((best, cur) => cur.totalMeters < best.totalMeters ? cur : best);

    //     // waypoint_order เป็น index เทียบกับ array ที่ตัด destIndex ออกแล้ว ต้อง map กลับ
    //     const remainingIndexes = destinations
    //       .map((_, i) => i)
    //       .filter(i => i !== bestResult.destIndex);
    //     const order = bestResult.route.waypoint_order.map(i => remainingIndexes[i]);
    //     order.push(bestResult.destIndex); // ปลายทางจริงอยู่ท้ายสุด

    //     this.processRouteResponse(origin, bestResult.route, order);
    //   });
    // },

    // ── ประมวลผลผลลัพธ์ Route และแสดงในตาราง/แผนที่ ──
    processRouteResponse(origin, route, order) {
      const legs = route.legs;

      // เวลา/ระยะทางรวมทั้งหมด
      const totalSeconds = legs.reduce((sum, leg) => sum + leg.duration.value, 0);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      if (minutes === 60) {
        hours += 1;
        minutes = 0;
      }
      this.workHourText = `${hours} ชั่วโมง ${minutes} นาที`
      const minutesAsDecimal = minutes / 100;
      this.workHourSuggestValue = Number((hours + minutesAsDecimal).toFixed(2));

      const totalMeters = legs.reduce((sum, leg) => sum + leg.distance.value, 0);
      const totalKilometers = Math.round((totalMeters / 1000) * 100) / 100;
      this.distanceSuggestValue = totalKilometers;
      this.consumptionRateSuggestValue = this.orderedCarOptions?.find((item)=> item.allHaveWork == false && item.leftWeight >= 0)?.consumption_rate || 0;
      this.suggestValue = order.map(i => this.destinations[i]);

      // สร้างข้อมูลตาราง
      let cumDistanceM = 0;
      let cumSeconds = 0;
      const orderedStops = order.map((destIndex, idx) => {
        const leg = legs[idx];
        cumDistanceM += leg.distance.value;
        cumSeconds += leg.duration.value;
        const stop = this.destinations[destIndex];
        return {
          ...stop,
          stopNumber: idx + 1,
          isOrigin: false,
          cumulative_distance: Math.round((cumDistanceM / 1000) * 100) / 100,
          eta: this.formatClockTime(this.startTime, cumSeconds),
        };
      });

      this.totalDistanceText = orderedStops.length
        ? orderedStops[orderedStops.length - 1].cumulative_distance
        : '0';

      const originRow = {
        name: 'ต้นทาง ' +this.originName,
        moving_type: this.originMoving,
        product_amount: this.originAmount,
        product_weight: this.originWeight,
        isOrigin: true,
        cumulative_distance: 0,
        eta: this.formatClockTime(this.startTime, 0),
      };

      this.routeRows = [originRow, ...orderedStops];

      // วาดแผนที่
      const relevantLegs = legs.slice(0, orderedStops.length);
      this.$nextTick(() => {
        this.renderRouteMap(origin, orderedStops, relevantLegs);
      });
    },

    // ── สร้างการจัดเรียงทั้งหมด (Permutations) ──
    generatePermutations(arr) {
      if (arr.length <= 1) return [arr];
      const result = [];

      for (let i = 0; i < arr.length; i++) {
        const current = arr[i];
        const remaining = arr.slice(0, i).concat(arr.slice(i + 1));
        const remainingPerms = this.generatePermutations(remaining);

        for (const perm of remainingPerms) {
          result.push([current, ...perm]);
        }
      }

      return result;
    },
    handleSourceChange(value) {
      if(this.isProjectValue){
        this.form.name = value?.place_type_id ? value?.name?.trim()||'' : value?.name?.trim();
        this.form.lat = value?.place_type_id ? value?.lat||'' : value?.location?.lat;
        this.form.lng = value?.place_type_id ? value?.lng||'' : value?.location?.lng;
      }else{
        const selected = this.optionsSelect.find(opt => opt.value === value);
        this.form.name = value  || '';
        this.form.lat = selected?.extra.dest_lat  || '';
        this.form.lng = selected?.extra.dest_lng  || '';
      }
      this.$refs.destinationForm.validateFields(['name']).catch(() => {});
    },
    moveTypeLabel(type) {
      if (type === 1 || type === 'up') return 'ยกสินค้าขึ้น';
      if (type === 2 || type === 'down') return 'เอาสินค้าลง';
      return '';
    },
    handleSubmit() {
      let newDestinations = [...this.destinations];
      if (this.editingIndex !== null) {
        newDestinations.splice(this.editingIndex, 1, { ...this.form });
      } else {
        newDestinations.push({ ...this.form });
      }

      this.$emit("update:destinations", newDestinations);

      if (!this.isProjectValue) {
        this.$emit("destinationText", this.form.name, "distance");
      }else{
        this.$emit("destinationText", this.form.name);
      }
      this.resetForm();
      this.showDrawer = false;
    },
    editDestination(record, index) {
      let options = [...this.optionsSelect];

      let found = options.find(opt => opt.value === record.name || opt.label === record.name);

      if (!found) {
        found = { value: String(record.name), label: String(record.name) };
        options.unshift(found);
      }

      this.form = {
        ...record,
        name: String(found.value)  // <-- make sure it's a primitive string
      };

      this.oldOptionSelect = [...options];

      this.editingIndex = index;
      this.showDrawer = true;
    },
    removeDestination(index) {
      this.destinations.splice(index, 1);
    },
    resetForm() {
      this.form = {
        name: '',
        moving_type: 1,
        product_amount: '',
        product_weight: ''
      };
      this.formKey++;
      this.oldOptionSelect = [];
      this.editingIndex = null;
    }
  }
};
</script>
<style scoped>
    .ant-table.ant-table-bordered > .ant-table-title{
        background: #fafafa;
        padding: 12px 24px !important;
        border-radius: 8px 8px 0 0;
    }
    .grey-alert {
      background-color: #f5f5f5; /* light grey background */
      border: 1px solid #555;
      color: #555; /* grey text */
      padding: 5px;
      border-radius: 8px;
    }
    .disabled {
      pointer-events: none;
      color: gray;
      cursor: not-allowed;
    }

    /* ── ใหม่: สไตล์สำหรับ route drawer ── */
    .route-map-container {
      width: 100%;
      height: 280px;
      border-radius: 8px;
      overflow: hidden;
      background: #eee; /* fallback ระหว่างรอโหลด */
      margin-bottom: 16px;
    }

    .summary-cards {
      display: flex;
      gap: 12px;
      margin-bottom: 4px;
    }
    .summary-card {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 12px;
      background: #fafafa;
    }
    .summary-card-2 {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #e5ecfa;
      border-radius: 8px;
      padding: 12px;
      background: #f7fafe;
    }
    .summary-card-3 {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #fbead7;
      border-radius: 8px;
      padding: 12px;
      background: #fdf8f3;
    }
    .summary-card-4 {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #e5effc;
      border-radius: 8px;
      padding: 12px;
      margin-top: 16px;
      background: #e5effc;
    }
    .summary-icon {
      font-size: 22px;
      color: #2563eb;
      background: #e8effe;
      border-radius: 50%;
      padding: 6px;
    }
    .summary-icon-2 {
      font-size: 22px;
      color: #fb7215;
      background: #ffe8d1;
      border-radius: 50%;
      padding: 6px;
    }
    .summary-title {
      font-size: 12px;
      color: #888;
    }
    .summary-sub {
      font-size: 14px;
      font-weight: 600;
      color: #222;
    }

    .row-index {
      color: #999;
      font-size: 12px;
      min-width: 14px;
      text-align: right;
    }

    .stop-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #ef4444;
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      flex-shrink: 0;
    }
    .stop-badge--origin {
      background: green;
    }

    /* ให้ตารางในหน้าคำนวณเส้นทางไม่บีบตัวจนอ่านยาก */
    .ant-drawer-body .ant-table-cell {
      white-space: normal;
      word-break: break-word;
    }

    .bottom-info-bar {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      margin-top: 20px;
      padding-top: 16px;
      border-top: 1px solid #eee;
    }
    .bottom-info-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex: 1;
    }
    .bottom-info-label {
      font-size: 11px;
      color: #999;
    }
    .bottom-info-value {
      font-size: 13px;
      font-weight: 500;
      color: #222;
    }
    .spin-icon {
      animation: spin-route-icon 1s linear infinite;
    }
    @keyframes spin-route-icon {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
</style>